export default __webpack_public_path__ + "locales/lo-LA/Payments.json?hash=1e06acc0d0e93d1476499af6c9fbfbc2";